export const columnHeader = [
  {
    key: 'type', name: 'Type', type: 'text', system: false, filter: true, required: true
  },
  {
    key: 'restrict', name: 'Restrict', type: 'text', system: false, filter: true, required: true
  },
  {
    key: 'reason', name: 'Reason', type: 'text', system: false, filter: false, required: false
  },
  {
	key: 'actions', name: '', type: 'actions', system: true, filter: false
  }
];

export const types = [
  {value: 'country', label: 'Country'},
  {value: 'email', label: 'Email'},
  {value: 'ip', label: 'IP'},
  {value: 'authorized-ip', label: 'Authorized IP'},
  {value: 'phone', label: 'Phone'}
];